import { io, Socket } from 'socket.io-client';
import { getAuthToken } from '../auth/session.js';

/**
 * En dev : même origine que la page (proxy Vite `/socket.io` → serveur).
 * En prod : `VITE_SERVER_URL` ou origine courante si l’API est sur le même hôte.
 */
export function resolveSocketServerUrl(): string {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return window.location.origin;
  }
  const env = import.meta.env.VITE_SERVER_URL;
  if (typeof env === 'string' && env.length > 0) return env;
  if (typeof window !== 'undefined') return window.location.origin;
  return 'http://localhost:3000';
}

const SERVER_URL = resolveSocketServerUrl();

/**
 * Client Socket.io pour la communication temps réel
 */
export const socketClient: Socket = io(SERVER_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
  auth: (cb) => cb({ token: getAuthToken() ?? undefined }),
});

// Gestion des événements de connexion
socketClient.on('connect', () => {
  console.log('✅ Connecté au serveur:', socketClient.id);
});

socketClient.on('disconnect', () => {
  console.log('❌ Déconnecté du serveur');
});

socketClient.on('connect_error', (error: Error) => {
  console.error('❌ Erreur de connexion:', error);
});
